import React from "react";
import ViewInquiryDetails from "../component/InquiryDetails/ViewInquiryDetails";

const InquiryDetails = () => {
  return (
    <>
      <ViewInquiryDetails />
    </>
  );
};

export default InquiryDetails;
